// AlertModal.jsx
import { Modal, Button } from "antd";

export default function AlertModal({ open, title, message, onClose }) {
  return (
    <Modal
      title={title || "Atenção"}
      open={open}
      footer={[
        <Button key="ok" type="primary" onClick={onClose}>
          OK
        </Button>
      ]}
      onCancel={onClose}
    >
      {message}
    </Modal>
  );
}
